import React from 'react';
import { BdsTypo, BdsIllustration } from '@/core/constants/webComponents';

interface BrandLogoProps {
  className?: string;
  illustrationWrapperClassName?: string;
  illustrationClassName?: string;
  altText?: string;
  text?: string;
}

export const BrandLogo: React.FC<BrandLogoProps> = ({
  className,
  illustrationWrapperClassName,
  illustrationClassName,
  altText = 'Brand icon',
  text = 'STILINGUE by',
}) => {
  return (
    <span className={className}>
      <BdsTypo variant="fs-12" margin={false}>
        {text}
      </BdsTypo>
      <span className={illustrationWrapperClassName}>
        <BdsIllustration
          type="brand"
          name="blip-ballon-blue-white-horizontal"
          alt={altText}
          class={illustrationClassName}
        >
        </BdsIllustration>
      </span>
    </span>
  );
};
